module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M12.709.313a.896.896 0 0 0-1.364 0C6.9 5.344.001 14.99.001 19.846c0 6.704 5.452 12.156 12.154 12.156s12.154-5.452 12.154-12.156C24.307 14.996 17.178 5.348 12.71.313zm.811 25.68a4.72 4.72 0 0 1-3.192-1.242c-.384-.354-.207-.75.299-.878a7.558 7.558 0 0 0 5.504-5.506c.126-.506.525-.683.878-.297a4.717 4.717 0 0 1 1.242 3.192 4.733 4.733 0 0 1-4.732 4.732z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/water-1.js
// module id = 1495
// module chunks = 14